import { render, staticRenderFns } from "./CommentLineWithMention.vue?vue&type=template&id=6c7fcb8b&scoped=true&"
import script from "./CommentLineWithMention.vue?vue&type=script&lang=js&"
export * from "./CommentLineWithMention.vue?vue&type=script&lang=js&"
import style0 from "./CommentLineWithMention.vue?vue&type=style&index=0&id=6c7fcb8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7fcb8b",
  null
  
)

export default component.exports